import React from "react";
import DynamicTable from "../../../../../../utils/Table/DynamicTable";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import {
  setSummaryButton,
  setSummaryDetails,
  setViewSummaryDrawer,
} from "../../../../../../slices/viewSummarySlice";
export default function TabSection({ pageData, setSelected, searchText }) {
  const dispatch = useDispatch();
  const columns = [
    {
      id: "title",
      label: "TITLE",
      width: "225px",
      filterable: true,
    },
    {
      id: "viewCounts",
      label: "VIEW COUNT",
      width: "225px",
      filterable: true,
    },

    { id: "likes", label: "LIKES COUNT", width: "225px", filterable: true },
    { id: "language", label: "LANGUAGE", width: "225px", filterable: true },
    { id: "subject", label: "SUBJECTS", width: "225px", filterable: true },
    { id: "description", label: "SUMMARY", width: "225px", filterable: true },
  ];

  const transformedRows = (pageData || [])?.map((row) => {
    // Handle language array of objects
    let languageDisplay = "French"; // default
    if (Array.isArray(row?.languages) && row.languages.length > 0) {
      languageDisplay = row.languages.map((lang) => lang.name).join(", ");
    } else if (row?.language) {
      // Fallback for single language (if needed)
      languageDisplay = row.language;
    }

    return {
      ...row,
      likes: row?.likes ?? "0",
      viewCounts: row?.views ?? "0",
      language: languageDisplay, // This will be the string of joined language names
      subject: row?.subjectName ?? "Unknown",
    };
  });
  const handleRow = (row) => {
    dispatch(setViewSummaryDrawer(true));
    dispatch(setSummaryDetails(row));
    dispatch(setSummaryButton(true));
    setSelected(row);
  };
  return (
    <Box sx={{ height: "100%", paddingBottom: "16px" }}>
      <DynamicTable
        columns={columns}
        rows={transformedRows}
        searchText={searchText}
        onRowClick={(row) => {
          handleRow(row);
        }}
        rowsPerPage={20}
      />
    </Box>
  );
}
TabSection.propTypes = {
  pageData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      viewCounts: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      likes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      language: PropTypes.string,
      subject: PropTypes.string,
      description: PropTypes.string,
    })
  ), // Optional array of objects with the specified shape
  setSelected: PropTypes.func, // Required function to handle row selection
};
